import React, { PureComponent, createContext } from 'react';
import injectSheet from 'react-jss';
import { Form } from 'antd';
import styles from './styles';
import { getBalanceBankUnpaid } from 'src/redux/actions/dashborad';
import { setBalanceBank } from 'src/redux/actions/dashborad';
import ChangeBalanceBankForm from 'src/containers/Dashboard/Tamaa/BankBalance/table.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

export const BankContext = createContext();

function mapStateToProps(state) {
	return {
		store: {
		}
	};
}

const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{
				getBalanceBankUnpaid,
				setBalanceBank
			},
			dispatch
		)
	};
};

@injectSheet(styles)
@connect(
	mapStateToProps,
	mapDispatchToProps
)
export default class BankBalance extends PureComponent {
	state = {
		data: [],
		total: 0,
	};

	componentDidMount() {
		this.getBalanceBankUnpaid();
	}

	getBalanceBankUnpaid = () => {
		const payload = {};
		this.props.action.getBalanceBankUnpaid(
			payload,
			(res) => {
				this.setState({ data: res, total: res[0].BankBalance + res[0].UnpaidBalance });
			}
		);
	}

	setNewBalance = (value) => {
		console.log(value);
		const payload = {
			params: value
		};
		this.props.action.setBalanceBank(
			payload,
			(res) => {
				this.getBalanceBankUnpaid()
			}
		);
	}

	render() {
		const form = Form.create();
		const { data } = this.state;
		const columns = [
			{
				title: 'Solde bancaire',
				dataIndex: 'BankBalance',
				key: 'BankBalance'

			},
			{
				title: 'Solde impayé',
				dataIndex: 'UnpaidBalance',
				key: 'UnpaidBalance'
			}
		]

		return (
			<BankContext.Provider
				value={{
					setBalanceBank: this.setNewBalance
				}}>
				<ChangeBalanceBankForm data={data} columns={columns} />
			</BankContext.Provider>
		);
	}
}
